import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Button} from "primeng/button";
import {Dialog} from "primeng/dialog";
import {PrimeTemplate} from "primeng/api";
import {IconBoldCloseSquareComponent} from '@components/icons/icon-bold-close-square/icon-bold-close-square.component';

@Component({
  selector: 'app-aviso-legal',
  imports: [
    Dialog,
    PrimeTemplate,
    Button,
    IconBoldCloseSquareComponent
  ],
  templateUrl: './aviso-legal.component.html',
  standalone: true,
  styleUrl: './aviso-legal.component.css'
})
export class AvisoLegalComponent {
  @Input() showDialog: boolean = false;
  @Output() showDialogChange = new EventEmitter<boolean>();

  readonly emailSicArtesp = 'artesp@sic.gov.br';
  readonly sicArtesp = 'Informações - (11) 3465-2000';
  readonly ouvidoriaArtesp = 'Ouvidoria - 0800 727 83 77';
  readonly emailOuvidoriaArtesp = 'ouvidoria@artesp.sp.gov.br';

  closeDialog(): void {
    this.showDialog = false;
    this.showDialogChange.emit(false);
  }
}
